import { Col, Container, Row } from "reactstrap";
import styles from "./Applicabilty.module.scss";
import DataTable from "react-data-table-component";
import { useState } from "react";

const Applicability = () => {
  const [showApplicability, setShowApplicability] = useState(false);

  const data = [
    { productId: "001", productName: "Blue headphones" },
    { productId: "001", productName: "Blue headphones" },
    { productId: "001", productName: "Blue headphones" },
  ];

  const columns = [
    { name: "Product ID", selector: (row) => row.productId, minWidth: "120px" },
    { name: "Product name", selector: (row) => row.productName, minWidth: "140px" },
    {
      name: "Action",
      selector: () => (
        <span
          onClick={() => setShowApplicability(!showApplicability)}
          className={styles["text-orange"]}
        >
          View
        </span>
      ),
      button: true,
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f2f2f2",
        fontSize: "0.938rem",
        fontWeight: 500,
        div: {
          whiteSpace: "normal",
          overflow: "visible",
        },
      },
    },
    cells: {
      style: {
        paddingBlock: "1rem",
        div: {
          whiteSpace: "normal !important",
          overflow: "visible !important",
        },
      },
    },
  };

  return (
    <section>
      <div className={styles["heading"]}>Applicability</div>
      <Container fluid className="px-5 d-flex flex-column gap-2 py-3">
        {showApplicability ? (
          <div>General Use</div>
        ) : (
          <>
            <div>
              <p>
                Total Applicable Products:{" "}
                <span className={styles["text-orange"]}>4</span>
              </p>
            </div>
            <Row className="g-0 gap-4">
              <Col>
                <DataTable
                  data={data}
                  columns={columns}
                  customStyles={customStyles}
                />
              </Col>
              <Col>
                <DataTable
                  data={data}
                  columns={columns}
                  customStyles={customStyles}
                />
              </Col>
            </Row>
          </>
        )}
      </Container>
    </section>
  );
};

export default Applicability;